import get from 'lodash.get';
import { PERIOD } from './CommonConstants';

const { BOY, MOY, EOY, BOY_MOY, MOY_EOY, AFTER_EOY } = PERIOD;

export const PM_SCORES_NUMBER = 3;
export const PM_COL_SPAN_SUBHEADER_CELL = 'pm-col-span subheader-cell';
export const PM_ROW_SPAN = 'pm-row-span';
export const HELP_PANEL_TAB = 'CS_PM';

export const TITLE = {
    PM_TITLE: 'Progress Monitoring',
    INTERVENTION_TITLE: 'Intervention',
    SKILL_TITLE: 'Skill',
};

export const KEY = {
    SKILL_KEY: 'skill',
    PERIOD_KEY: 'period',
};

export const PM_PERIODS = [
    { key: BOY_MOY, title: `${BOY}-${MOY}` },
    { key: MOY_EOY, title: `${MOY}-${EOY}` },
    { key: AFTER_EOY, title: `After ${EOY}` },
];

export const getPeriodByKey = (periods, periodKey) =>
    periods.find(period => get(period, 'key', '') === periodKey);

export const INDEX = {
    LAST_SCORES_START: 4,
    LAST_SCORES_END: 6,
    LAST_GRID_HEADER: 10,
    FIRST_INTERVENTION_HEADER: 11,
    LAST_INTERVENTION_HEADER: 14,
};

export const PROGRESS_TABLE_SORTABLE_COLUMNS = [0, 1, 11, 12, 13, 14];

export const PROGRESS_HEADER_VIEW = [
    {
        isGridHeader: true,
        isSubheader: true,
        rowObject: {},
    },
];
